import { ProjectDetailPageV6 as BaseProjectDetailPage } from "./ProjectDetailPageV6";

// project-detail-recovery-v43
export const ProjectDetailPageV7 = () => (
  <BaseProjectDetailPage />
);
